'use strict';

require(['componentLoader'], function (helper) {
  // Make these modules dependencies
  helper.requireDependencies();
});

define(['siteObj'], function (siteObj) {

  var espa = function espa() {
    var self = this;

    function initAccountPageScript() {
      if (siteObj.page === 'account-creation') {
        require(['accountCreate']);
      }
    }

    function init() {

      self.initAccountPageScript();

      /* Javascript Healthcheck - Please keep this at the bottom of the file. */
      var healthCheck = document.createElement('span');
      healthCheck.id = 'jshealthcheck';
      document.body.appendChild(healthCheck);
    }

    self.init = init;
    self.initAccountPageScript = initAccountPageScript;
  };

  var espaSite = new espa();
  espaSite.init();
  return espaSite;
});
//# sourceMappingURL=espa.js.map
